/* MI — FREE-SHIPPING GOAL IS $79 USD, IN EVERY CURRENCY.
 *
 * The store's BASE currency is USD; CHF/EUR/etc are presentment currencies
 * (Shopify.currency = {active:"CHF", rate:"0.80409"}). Liquid's
 * cart.items_subtotal_price is in the PRESENTMENT currency, but
 * settings.cart_progress_threshold is a raw number — so the stock snippet was
 * comparing CHF against a USD-shaped number. A CHF 56.99 cart (= $70.87)
 * cleared a "50" goal and printed "Congrats! You get FREE shipping!".
 *
 * Fix: the goal ships as BASE-currency cents in a data attribute, and this
 * converts it into whatever the shopper is being shown. presentment = base * rate.
 *
 * ⛔ WHY A CUSTOM ELEMENT AND NOT AN INLINE SCRIPT: the cart drawer re-renders
 * by assigning innerHTML from the Section Rendering API. Scripts inside injected
 * HTML never execute — but custom elements upgrade on insertion, so
 * connectedCallback fires again on every cart update. That is the only hook here
 * that survives a re-render.
 */
class MiCartProgressGoal extends HTMLElement {
  connectedCallback() { this.recalc(); }

  recalc() {
    const baseCents = parseInt(this.dataset.goalBaseCents || '0', 10);
    const subCents  = parseInt(this.dataset.subtotalCents || '0', 10);
    if (!baseCents) return;

    const cur  = (window.Shopify && window.Shopify.currency) || {};
    const rate = parseFloat(cur.rate) || 1;
    const goal = baseCents * rate;                       // goal in presentment cents

    const pct     = Math.min(100, (subCents / goal) * 100);
    const reached = subCents >= goal;

    const bar = this.querySelector('.cart-progress__bar__progress');
    if (bar) bar.style.width = pct + '%';

    const text = this.querySelector('.cart-progress__text');
    if (!text) return;

    if (reached) {
      text.innerHTML = this.dataset.successMessage || '';
    } else {
      // round the shortfall UP — never tell someone they need less than they do
      const shortfall = Math.ceil((goal - subCents) / 100);
      text.innerHTML = (this.dataset.message || '').replace(
        '[amount]', '<span>' + this.formatMoney(shortfall, cur.active) + '</span>'
      );
    }
  }

  formatMoney(amount, code) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: code || 'USD',
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return (code || '$') + ' ' + amount;
    }
  }
}
if (!customElements.get('mi-cart-progress-goal')) {
  customElements.define('mi-cart-progress-goal', MiCartProgressGoal);
}
